export default (line: string): number => {
  return parseInt(
    line
      .split(/(#\d+=)|(#\d+ =)/)[1]
      .replace('#', '=')
      .replace('=', '')
  )
}
